import { ProblemDefinition } from './types';

const schemaDDL = `
CREATE TABLE departments (id INTEGER PRIMARY KEY, name TEXT NOT NULL, budget REAL);
CREATE TABLE employees (id INTEGER PRIMARY KEY, first_name TEXT NOT NULL, last_name TEXT NOT NULL, dept_id INTEGER, salary REAL, hire_date TEXT, manager_id INTEGER, FOREIGN KEY(dept_id) REFERENCES departments(id), FOREIGN KEY(manager_id) REFERENCES employees(id));
`;

const seedDML = `
INSERT INTO departments (id, name, budget) VALUES
  (1, 'Engineering', 500000),
  (2, 'Sales', 300000),
  (3, 'Marketing', 200000),
  (4, 'HR', 150000);

INSERT INTO employees (id, first_name, last_name, dept_id, salary, hire_date, manager_id) VALUES
  (1, 'Alice', 'Johnson', 1, 95000, '2020-03-15', NULL),
  (2, 'Bob', 'Smith', 1, 88000, '2021-06-01', 1),
  (3, 'Carol', 'Williams', 2, 72000, '2019-11-20', NULL),
  (4, 'David', 'Brown', 2, 65000, '2022-01-10', 3),
  (5, 'Eva', 'Davis', 3, 78000, '2020-07-22', NULL),
  (6, 'Frank', 'Miller', 1, 92000, '2018-09-05', 1),
  (7, 'Grace', 'Wilson', NULL, 60000, '2023-02-14', NULL),
  (8, 'Henry', 'Taylor', 3, 70000, '2021-04-30', 5),
  (9, 'Ivy', 'Anderson', 4, 67000, '2022-08-18', NULL),
  (10, 'Jack', 'Thomas', NULL, 55000, '2023-05-01', NULL);
`;

export const selectProblems: ProblemDefinition[] = [
 {
  id: 'select-easy-1',
  title: 'List All Employees',
  statement: `Write a query to retrieve **all columns** from the \`employees\` table.\n\nReturn every row and every column.`,
  schemaDDL,
  seedDML,
  expectedOutput: {
   columns: ['id', 'first_name', 'last_name', 'dept_id', 'salary', 'hire_date', 'manager_id'],
   values: [
    [1, 'Alice', 'Johnson', 1, 95000, '2020-03-15', null],
    [2, 'Bob', 'Smith', 1, 88000, '2021-06-01', 1],
    [3, 'Carol', 'Williams', 2, 72000, '2019-11-20', null],
    [4, 'David', 'Brown', 2, 65000, '2022-01-10', 3],
    [5, 'Eva', 'Davis', 3, 78000, '2020-07-22', null],
    [6, 'Frank', 'Miller', 1, 92000, '2018-09-05', 1],
    [7, 'Grace', 'Wilson', null, 60000, '2023-02-14', null],
    [8, 'Henry', 'Taylor', 3, 70000, '2021-04-30', 5],
    [9, 'Ivy', 'Anderson', 4, 67000, '2022-08-18', null],
    [10, 'Jack', 'Thomas', null, 55000, '2023-05-01', null],
   ],
  },
  comparisonMode: 'order-insensitive',
  difficulty: 'easy',
  topicTags: ['select'],
  hints: ['Use SELECT * to retrieve all columns from a table.'],
 },
 {
  id: 'select-easy-2',
  title: 'Employee Names and Salaries',
  statement: `Write a query to retrieve only the **first name**, **last name**, and **salary** of each employee.`,
  schemaDDL,
  seedDML,
  expectedOutput: {
   columns: ['first_name', 'last_name', 'salary'],
   values: [
    ['Alice', 'Johnson', 95000],
    ['Bob', 'Smith', 88000],
    ['Carol', 'Williams', 72000],
    ['David', 'Brown', 65000],
    ['Eva', 'Davis', 78000],
    ['Frank', 'Miller', 92000],
    ['Grace', 'Wilson', 60000],
    ['Henry', 'Taylor', 70000],
    ['Ivy', 'Anderson', 67000],
    ['Jack', 'Thomas', 55000],
   ],
  },
  comparisonMode: 'order-insensitive',
  difficulty: 'easy',
  topicTags: ['select'],
  hints: ['List only the columns you need after SELECT, separated by commas.'],
 },
 {
  id: 'select-easy-3',
  title: 'Unique Departments',
  statement: `Write a query to retrieve the **distinct department IDs** from the \`employees\` table.\n\nInclude NULL values if any employee has no department assigned.`,
  schemaDDL,
  seedDML,
  expectedOutput: {
   columns: ['dept_id'],
   values: [
    [1],
    [2],
    [3],
    [4],
    [null],
   ],
  },
  comparisonMode: 'order-insensitive',
  difficulty: 'easy',
  topicTags: ['select'],
  hints: ['Use SELECT DISTINCT to eliminate duplicate values.'],
 },
 {
  id: 'select-medium-1',
  title: 'Full Names with Concatenation',
  statement: `Write a query that returns each employee's **full name** (first name and last name joined by a space) and their **salary**.\n\nAlias the full name column as \`full_name\`.`,
  schemaDDL,
  seedDML,
  expectedOutput: {
   columns: ['full_name', 'salary'],
   values: [
    ['Alice Johnson', 95000],
    ['Bob Smith', 88000],
    ['Carol Williams', 72000],
    ['David Brown', 65000],
    ['Eva Davis', 78000],
    ['Frank Miller', 92000],
    ['Grace Wilson', 60000],
    ['Henry Taylor', 70000],
    ['Ivy Anderson', 67000],
    ['Jack Thomas', 55000],
   ],
  },
  comparisonMode: 'order-insensitive',
  difficulty: 'medium',
  topicTags: ['select'],
  hints: [
   'Use the || operator to concatenate strings in SQLite.',
   'Example: first_name || \' \' || last_name AS full_name',
  ],
 },
];
